import { useEffect, useState, useMemo, useRef } from "react";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import { Drawer, Grid2, TextField } from "@mui/material";
import { DrawerHeader } from "../../../_components/drawer/header.drawer";
import { FileTypeEnum } from "../../../_common/enum/fileType.enum";
import { ValidatorForm } from "react-material-ui-form-validator";
import { StandardButton } from "../../../_components/button/primary.button";
import { fileUploadService } from "../../../_services/fileUpload.service";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { IFilteringViewModel } from "../../../_common/interface/table";
import { getEnumKey } from "../../../_helpers/enum.helper";
import { toastr } from "../../../_components/toastr/toastr";
import { accountService } from "../../../_services/accounts.service";
import EnumSelect from "../../../_components/autocomplete/enum.select";
import { UserTypeEnum } from "../../../_common/enum/userType.enum";

export const TicketFileDrawer = (params: { isOpen?: boolean, onSave(): void, onClose(): void, fileType: FileTypeEnum, }) => {

    const resetData = () => ({ fileName: "" });
    const [data, setData] = useState<any>(resetData);

    const { id } = useParams<{ id: string }>();
    const { fileType } = params;
    const [upload, updateUpload] = useState<{ ticketId: number | null, fileTypeId: number | null, file: any | null }>({ ticketId: 0, fileTypeId: 0, file: null });
    const [isLoading, setIsLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [saving, setIsSaving] = useState(false);

    const fileInputRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        if (isOpen == false)
            setIsOpen(true);
    }, []);


    function onUploadChange(event: any) {
        const _upload = upload
        const selectedFile = event.target.files[0];
        _upload.file = selectedFile;
        updateUpload({ ..._upload });
        setData((_data: any) => ({
            ..._data,
            fileName: _data?.fileName?.trim()?.length ? _data.fileName : (selectedFile?.name || "")
        }));
    }

    const clearFile = () => {
        updateUpload({ ...upload, file: null });
        setData((_data: any) => ({ ..._data, fileName: "" }));
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    function handleChange(event: any) {
        setData((_data: any) => ({ ..._data, [event.target.name]: event.target.value }));
    }

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);
        console.log(data);
        const formData = new FormData();
        formData.append("file", upload.file);
        formData.append("fileName", data?.fileName || "");

        if (accountService.isAdmin || accountService.isUser)
            formData.append("userTypeId", data?.userTypeId);

        //get the id type we need based on the FileType -> caseId, ticketId, etc
        formData.append(getEnumKey(fileType, FileTypeEnum).toLowerCase() + "Id", (id || 0)?.toString());

        formData.append("fileTypeId", (fileType || 0)?.toString());

        return fileUploadService
            .uploadFile(formData)
            .then(
                () => {
                    toastr.success("File Upload was successful.");
                    clearFile();
                    params.onSave();
                },
                handleErrorResponse
            )
            .finally(() => setIsSaving(false));
    }

    return (
        <Drawer
            anchor={"right"}
            variant="persistent"
            open={isOpen}
            ModalProps={{
                keepMounted: true
            }}>

            <DrawerHeader name={"File"} onClose={params.onClose} />
            <ValidatorForm onSubmit={submit} noValidate style={{ padding: "4px" }}>
                <Grid2 container spacing={2}>

                    {(accountService.isAdmin || accountService.isUser) &&
                        <Grid2 size={{ xs: 12 }}>
                            <EnumSelect
                                enumObject={UserTypeEnum}
                                label="Select User Type"
                                name="userTypeId"
                                value={data.userTypeId}
                                onChange={handleChange}
                                required />
                        </Grid2>
                    }

                    <Grid2 size={{ xs: 12 }}>
                        <TextField
                            label="File Name"
                            name="fileName"
                            value={data?.fileName || ""}
                            onChange={handleChange}
                            required
                            fullWidth
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <TextField
                            label="File to Upload"
                            type="file"
                            id="TicketFile"
                            required
                            fullWidth
                            onChange={onUploadChange}
                            inputRef={fileInputRef}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardButton
                            saving={saving}
                            loading={isLoading}
                            icon="save"
                            type="submit"
                        >
                            Save
                        </StandardButton>
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardButton
                            saving={saving}
                            loading={isLoading}
                            icon="block"
                            variant="error"
                            onClick={clearFile}>
                            Cancel
                        </StandardButton>
                    </Grid2>
                </Grid2>
            </ValidatorForm>
        </Drawer >
    );

}